"use client";
import React from 'react';
import dynamic from "next/dynamic";
import { useRouter } from 'next/navigation';
import EventList from '@/components/lottery/EventList';

const WalletConnect = dynamic(
  () => import("@/components/wallet/WalletConnect").then(mod => mod.ClientWalletConnect),
  { ssr: false }
);

const EventsPage = () => {
  const router = useRouter();
  return (
    <main className="min-h-screen bg-[#0a0a0a] text-gray-100">
      {/* Wallet Connect Button - Top Right Corner */}
      <div className="absolute top-4 right-4 z-50">
        <WalletConnect />
      </div>

      {/* Back Button - Top Left Corner */}
      <div className="absolute top-4 left-4 z-50">
        <button
          onClick={() => router.back()}
          className="px-4 py-2 text-sm font-medium text-white bg-gray-600 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          Quay lại
        </button>
      </div>

      <section className="w-full flex flex-col items-center justify-center text-center py-24 px-4 relative">
        <div className="absolute inset-0 pointer-events-none z-0">
          <div className="w-full h-full bg-gradient-to-br from-purple-900/40 via-indigo-900/30 to-black/80 blur-2xl"></div>
        </div>
        <h1 className="relative z-10 text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-6 drop-shadow-lg">
          Danh sách sự kiện
        </h1>
        <p className="relative z-10 max-w-xl text-lg md:text-xl text-purple-200 mb-8">
          Khám phá các sự kiện NFT đã được tạo và tham gia mua vé
        </p>
      </section>

      <section className="w-full py-12 px-4">
        <EventList />
      </section>
    </main>
  );
};

export default EventsPage; 